export default __webpack_public_path__ + "static/media/logo.551a0eb7.png";